import { render, staticRenderFns } from "./CarCard.vue?vue&type=template&id=31a90308&scoped=true&"
import script from "./CarCard.vue?vue&type=script&lang=js&"
export * from "./CarCard.vue?vue&type=script&lang=js&"
import style0 from "./CarCard.vue?vue&type=style&index=0&id=31a90308&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a90308",
  null
  
)

export default component.exports